<template>
  <dx-document-upload-form
    next-step-path="PartnerPortal-ReportDamage-Deadline"
    previous-step-path="PartnerPortal-ReportDamage-Facts"
  />
</template>

<script>
import DxDocumentUploadForm from '~/components/reportDamage/DX-DocumentUploadForm'

export default {
  name: 'PartnerReportDamageDocumentUpload',
  components: {
    DxDocumentUploadForm,
  },
  layout: 'non-sticky-nav',
  nuxtI18n: {
    paths: {
      de: '/partnerportal/schaden-melden/dokumentenupload',
      fr: '/portailpartenaires/dommages-rapport/telecharger-un-document',
      it: '/portaledeipartner/danni-report/carica-documento',
    },
  },
}
</script>
